
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/jurisdictionSlice";
import { removeMultipleJurisdictions } from "slices/jurisdictionSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { fetchJurisdictions } from "slices/jurisdictionSlice";
import { jurisdictionSelector } from "slices/jurisdictionSlice";
import AddJurisdiction from "components/jurisdiction/AddJurisdiction";
import { convertTimeToUTCFormatted } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";

const apiService = new Api();

function JurisdictionsList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { jurisdiction: jurisdiction, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(jurisdictionSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });

  React.useEffect(() => {
    dispatch(fetchJurisdictions())
  }, [])

  const handleAddLocationPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchJurisdictions())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleJurisdictions({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(jurisdiction?.map((jurisdiction) => jurisdiction.id.toString()))
  }

  const handleClose = () => {
    refAddutton.current.click(); setAddForm({ show: false })
  };

  //#region TABLE HEAD

  const renderTableHeader = React.useCallback(() => {

    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchJurisdictions(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }

    return (
      <tr>
        <th >
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Jurisdictions') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th >
          <TableHeaderItem
            title="Jurisdiction"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th >
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status Jurisdictions') &&
          <th >Status</th>
        }
        {checkPermission('Edit Jurisdictions') &&
          <th >Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      jurisdiction?.map((jurisdiction, index) => (
        <JurisdictionItems jurisdiction={jurisdiction} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddLocationPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [jurisdiction, selectedItems]);

  //#endregion


  return (
    <ListLayout
      heading="Jurisdictions"
      time={true}
      title=""
      buttonTitle="Add jurisdiction"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      addButtonDisabled={!checkPermission('Create Jurisdictions')}
      totalPages={totalPages}
      fetchList={fetchJurisdictions}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddJurisdiction item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status Jurisdictions')} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddLocationPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search jurisdiction..."
      noOfItems={total}

    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}


const JurisdictionItems = ({
  jurisdiction, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(jurisdiction?.status);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));
  }

  React.useEffect(() => {
    setStatus(jurisdiction?.status)
  }, [jurisdiction])

  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Jurisdictions') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={jurisdiction.id} checked={selectedItems.includes(jurisdiction.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {jurisdiction.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {convertTimeToUTCFormatted(jurisdiction.created_at)}
      </td>
      {checkPermission('Status Jurisdictions') &&
        <td style={getBackgroundStyle(status)}>
          <CustomSwitch handleChange={(status) => handleStatusChange(jurisdiction?.id, status)} checked={status == 1 ? true : false} />
        </td>
      }
      {checkPermission('Edit Jurisdictions') &&
        <td style={getBackgroundStyle(status)}>
          <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleAddPopUp({ ...jurisdiction, status })}>Edit</button>
        </td>
      }
    </tr>
  )
}


export default JurisdictionsList;
